import countries from "./countries.json";

const countriesMap = countries as Record<string, Record<string, unknown>>;

export function getCountryCode(countryName: string): string {
  return (
    (countriesMap[countryName]?.code as string) || "Country code not found"
  );
}

export function getCountryContinent(countryName: string): string {
  return (
    (countriesMap[countryName]?.continent as string) || "Continent not found"
  );
}

export function getCountryGoodWeatherSeason(
  countryName: string,
): string[] | string {
  return (
    (countriesMap[countryName]?.goodWeatherSeason as string[]) ||
    "good weather season not found"
  );
}

export function getCountrySurfSeason(countryName: string): string[] | string {
  return (
    (countriesMap[countryName]?.surfSeason as string[]) ||
    "surf season not found"
  );
}

export function getCountryLifecost(countryName: string): number | string {
  return (
    (countriesMap[countryName]?.lifeCost as number) ?? "lifecost not found"
  );
}

export function getCountriesList(): string[] {
  return Object.keys(countriesMap).sort();
}
